import styled from "styled-components";

export const FilterContainer = styled.div`
  display: flex;
  height: 48px;
  align-items: center;
  .ant-form.ant-form-vertical,
  .ant-form-item {
    height: 48px;
  }
`;
